var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-wrapper"},[_c('div',{staticClass:"section-content-wrapper max-content-width"},[_vm._t("default",[_c('h2',[_vm._v("I'm a section!")]),_c('h4',[_vm._v("This is a subtitle for a section")])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }